import React from 'react';
import { getStudentData, getGroupsData } from '../assets/data';
import './LibraryFilters.css';

export default function LibraryFilters({ mode, filters, onChange }) {
  const toggle = (key, value) => {
    onChange({ ...filters, [key]: value });
  };

  const toggleMulti = (key, value) => {
    const set = new Set(filters[key] || []);
    if (set.has(value)) set.delete(value); else set.add(value);
    onChange({ ...filters, [key]: Array.from(set) });
  };

  const cefrLevels = ['A1','A2','B1','B2','C1','C2'];
  const mediums = ['video','text','audio'];

  return (
    <aside className="library-filters">
      <div className="filters-header">Filters</div>

      <div className="filter-block">
        <div className="block-title">CEFR</div>
        <div className="chips">
          {cefrLevels.map(l => (
            <button key={l} className={`chip ${filters.cefr?.includes(l) ? 'active' : ''}`} onClick={() => toggleMulti('cefr', l)}>{l}</button>
          ))}
        </div>
      </div>

      <div className="filter-block">
        <div className="block-title">Medium</div>
        <div className="chips">
          {mediums.map(m => (
            <button key={m} className={`chip ${filters.mediums?.includes(m) ? 'active' : ''}`} onClick={() => toggleMulti('mediums', m)}>{m}</button>
          ))}
        </div>
      </div>

      {mode === 'global' && (
        <>
          <div className="filter-block">
            <div className="block-title">Price</div>
            <div className="chips">
              {['free','paid'].map(p => (
                <button key={p} className={`chip ${filters.price === p ? 'active' : ''}`} onClick={() => toggle('price', p)}>{p === 'free' ? 'Free' : 'Paid'}</button>
              ))}
            </div>
          </div>

          <div className="filter-block">
            <div className="block-title">Sort</div>
            <select value={filters.sort || 'newest'} onChange={(e) => toggle('sort', e.target.value)} className="select">
              <option value="newest">Newest</option>
              <option value="popular">Popular</option>
              <option value="price_low">Price: Low to High</option>
              <option value="price_high">Price: High to Low</option>
            </select>
          </div>
        </>
      )}

      {mode === 'personal' && (
        <>
          <div className="filter-block">
            <div className="block-title">Ownership</div>
            <div className="chips">
              {[
                { key: 'mine', label: 'My lessons' },
                { key: 'purchased', label: 'Purchased' },
                { key: 'published', label: 'Published' },
                { key: 'studentHistory', label: "Student's history" },
              ].map(opt => (
                <button key={opt.key} className={`chip ${filters.ownership === opt.key ? 'active' : ''}`} onClick={() => toggle('ownership', opt.key)}>{opt.label}</button>
              ))}
            </div>
          </div>

          {filters.ownership === 'studentHistory' && (
            <>
              <div className="filter-block">
                <div className="block-title">History type</div>
                <div className="chips">
                  {[
                    { key: 'student', label: 'Student' },
                    { key: 'group', label: 'Group' },
                  ].map(opt => (
                    <button key={opt.key} className={`chip ${((filters.historyType||'student') === opt.key) ? 'active' : ''}`} onClick={() => toggle('historyType', opt.key)}>{opt.label}</button>
                  ))}
                </div>
              </div>
              {(() => {
                const historyType = filters.historyType || 'student';
                if (historyType === 'student') {
                  const studentsObj = getStudentData() || {};
                  const students = Object.entries(studentsObj).map(([id, s]) => ({ id, name: s.name || id }));
                  const sorted = students.sort((a,b) => a.name.localeCompare(b.name));
                  return (
                    <div className="filter-block">
                      <div className="block-title">Student</div>
                      <select className="select" value={filters.studentId || ''} onChange={(e) => toggle('studentId', e.target.value)}>
                        <option value="">Select student…</option>
                        {sorted.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                      </select>
                    </div>
                  );
                } else {
                  const groupsObj = getGroupsData() || {};
                  const groups = Object.values(groupsObj);
                  const sorted = groups.sort((a,b) => (a?.name||'').localeCompare(b?.name||''));
                  return (
                    <div className="filter-block">
                      <div className="block-title">Group</div>
                      <select className="select" value={filters.groupId || ''} onChange={(e) => toggle('groupId', e.target.value)}>
                        <option value="">Select group…</option>
                        {sorted.map(g => <option key={g.id} value={g.id}>{g.name || g.id}</option>)}
                      </select>
                    </div>
                  );
                }
              })()}
            </>
          )}
        </>
      )}

      <button className="chip reset-chip" onClick={() => onChange({})}>Reset</button>
    </aside>
  );
}


